const PostLoginActionCreatorUtil = require('../../util/post_login_actions/post_login_creator.js');

/**
 * This service has methods for creating a "post login action" on the server side.
 *
 * A typical "post login action" starts when the user is logged out and
 * continues after the user has been redirected to the login page, and then
 * redirected back to the original page after logging in.
 *
 * An example flow would go through these steps:
 *
 *  1. The user tries to add a variation to a web project.
 *  2. Before adding the variation, the authentication service will check to see
 *     if the user is logged in.
 *  3. If the user isn't logged in, the authentication service will use
 *     PostLoginActionCreatorService to create a post login action on the server
 *     side that stores the type of action the user was trying to execute, along
 *     with any data needed to continue the action.
 *  4. The authentication service will append the new post action's id to the url and
 *     then redirect the user to the login page.
 *  5. The user will log in and get redirected back to the original page url
 *     that also contains the post login action id.
 *  6. The app will see the post login action id in the url and use
 *     PostLoginActionProcessorService to request the data it needs to continue the
 *     action.
 *
 * @deprecated Replaced by the standalone Post Login Action Creator util
 * @ngInject
 */
function PostLoginActionCreatorService() {
  return {
    ...PostLoginActionCreatorUtil
  };
}

module.exports = PostLoginActionCreatorService;
